export default __webpack_public_path__ + "static/media/switcheroo.2a3b4750.svg";